(function () {
    'use strict';

    angular
        .module('superChannelApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'Channel'];

    function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, JhiLanguageService, Channel) {
        var vm = this;

        vm.authorities = ['ROLE_AGENT', 'ROLE_ADMIN', 'ROLE_SUPERVISOR'];
        vm.channels = [];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Channel.query(function (channels) {
            vm.channels = channels;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
